export default function (value, type = 'identifier') {
	let starText = '';
	if (value) {
		switch (type) {
			case 'identifier':
				for (let i = 0; i < value.length - 3; i++) {
					starText += '*';
				}
				starText += value.slice(-3);
				break;
			case 'accountNumber':
				for (let i = 0; i < value.length - 5; i++) {
					starText += '*';
				}
				starText = value.substring(0, 5) + starText;
				break;
			default:
		}
	}
	return starText;
}
